/**
 * Formsy-React文档：https://github.com/formsy/formsy-react/blob/2.0-documentation/API.md
 */
import Formsy from 'formsy-react';
import React from 'react';
export const Form = React.forwardRef((props, ref) => {
    const { children } = props;
    return (React.createElement(Formsy, Object.assign({}, props, { ref: ref }), children));
});
Form.displayName = 'Form';
export * from 'formsy-react';
export { default as FormValidator } from './validator';
export default Form;
